import React from 'react'
import injectStyles from 'react-jss'

import { Breadcrumbs, Typography } from '@material-ui/core'
import NavigateNextIcon from '@material-ui/icons/NavigateNext'
import { styles } from './styles'
import { Link } from 'react-router-dom'

const StyledBreadcrumbs = ({ classes, icon, breadcrumbs = [] }) => {
  return (
    <div className={classes.breadcrumbsWrapper}>
      {icon ? <div className={classes.icon}>{icon}</div> : null}
      <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />}>
        {breadcrumbs.map((breadcrumb, key) => {
          if (breadcrumb.link && breadcrumb.label !== 'Loading name...') {
            return (
              <Link
                color="inherit"
                to={breadcrumb.link}
                className={classes.link}
                key={key}
              >
                {breadcrumb.label}
              </Link>
            )
          } else {
            return (
              <Typography
                color="textPrimary"
                className={classes.link}
                key={key}
              >
                {breadcrumb.label}
              </Typography>
            )
          }
        })}
      </Breadcrumbs>
    </div>
  )
}

export default injectStyles(styles)(StyledBreadcrumbs)
